import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import styles from './govtIdCaptureScreen.module.css';

import { ReactComponent as BackArrow } from 'asset/IconsPack/at_arrow-left-thin.svg';
import { ReactComponent as HourglassIcon } from 'asset/IconsPack/at_hourglass-02-filled.svg';
import idIllustration from 'asset/img/govt-id-front-illustration.png';

import ScreenFrame from '../../components/ScreenFrame';
import Stepper from '../../components/Stepper';
import ThemedButton from '../../components/ThemedButton';
import { GOVT_ID_COPY } from '../../helper/constants';
import AcceptedDocuments from './AcceptedDocuments';

const header = (
    <Box className={styles.header}>
        <BackArrow className={styles.backArrow} />
        <Typography className={styles.headerTitle}>{GOVT_ID_COPY.HEADER}</Typography>
    </Box>
);

const GovtIdCaptureScreen = ({ logo, title, acceptedDocuments, steps }) => (
    <ScreenFrame
        logo={logo}
        header={header}
        stepper={steps && <Stepper steps={steps} activeStep={1} />}
        cardClassName={styles.card}
        bodyClassName={styles.body}
        footerClassName={styles.footer}
        footer={
            <>
                <Box className={styles.captureTray}>
                    <ThemedButton>{GOVT_ID_COPY.CAPTURE}</ThemedButton>
                </Box>
                <Box className={styles.session}>
                    <Typography className={styles.sessionInfo}>
                        {GOVT_ID_COPY.SESSION_INFO}
                    </Typography>
                    <Box className={styles.timer}>
                        <HourglassIcon className={styles.timerIcon} />
                        <Typography className={styles.timerValue}>
                            {GOVT_ID_COPY.SESSION_TIMER}
                        </Typography>
                    </Box>
                </Box>
            </>
        }
    >
        <Typography className={styles.title}>{title}</Typography>
        {acceptedDocuments && <AcceptedDocuments {...acceptedDocuments} />}
        <Box component="img" src={idIllustration} alt="" className={styles.illustration} />
        <Typography className={styles.tips}>{GOVT_ID_COPY.TIPS_LINK}</Typography>
    </ScreenFrame>
);

GovtIdCaptureScreen.propTypes = {
    logo: PropTypes.string,
    title: PropTypes.string.isRequired,
    acceptedDocuments: PropTypes.shape({
        inline: PropTypes.bool,
        labels: PropTypes.arrayOf(PropTypes.string),
    }),
    steps: PropTypes.arrayOf(PropTypes.string),
};

export default GovtIdCaptureScreen;
